<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 공정 이상 원인 -->
							<th class="col-1" rowspan="2">{{ getMessage_('QWCC001441') }}</th>
							<td class="col-5" rowspan="2">
								<el-input
									type="textarea"
									:rows="5"
									:value="detailForm.powPrbmCaus"
									:placeholder="getMessage_('QWCC001446')"
									maxlength="200"
									:show-word-limit="true"
									@input="val => setDetailForm(val, 'powPrbmCaus')"
									:readonly="setDisabled"
								/>
							</td>
							<!-- 개선대책 -->
							<th class="col-1" rowspan="2">{{ getMessage_('QWCC001443') }}</th>
							<td class="col-4" rowspan="2">
								<el-input
									type="textarea"
									:rows="5"
									:value="detailForm.bttmMdvSbc"
									:placeholder="getMessage_('QWCC001446')"
									maxlength="200"
									:show-word-limit="true"
									@input="val => setDetailForm(val, 'bttmMdvSbc')"
									:readonly="setDisabled"
								/>
							</td>
							<!-- 회신자 -->
							<th class="col-1">{{ getMessage_('QWCC001445') }}</th>
						</tr>
						<tr>
							<td class="col-1">
								{{ getAffrInfo_.mdvNm }}
							</td>
						</tr>
						<tr>
							<!-- 이력 -->
							<th rowspan="2">{{ getMessage_('SWCC000747') }}</th>
							<td class="col-3" rowspan="2">
								<rmk-history :rmkHistory="rmkHistory"></rmk-history>
							</td>
							<!-- 파일첨부 -->
							<th class="col-1" rowspan="3">{{ getMessage_('QWCC000039') }}</th>
							<td class="col-3" rowspan="3">
								<file-upload-list
									id="powCausFileUpload"
									width="100%"
									height="100%"
									:propFileList="detailForm.powCausFileDb"
									maxQuantity="3"
									@MultiFile="powCausFileUpload"
									@onDownload="onDownloadFile"
									:isEditable="!setDisabled"
								></file-upload-list>
							</td>
							<!-- 대책일자 -->
							<th class="col-1">{{ getMessage_('QWCC001444') }}</th>
						</tr>
						<tr>
							<td class="col-1">
								<el-date-picker
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									:value="detailForm.mdvDd?.replaceAll('-', '')"
									@input="val => setDetailForm(val, 'mdvDd')"
									:readonly="setDisabled"
								/>
							</td>
						</tr>
						<tr>
							<!-- 비고 -->
							<th class="col-1">{{ getMessage_('QWCC000906') }}</th>
							<td colspan="1">
								<el-input
									:value="detailForm.rmk"
									:placeholder="getMessage_('QWCC001447')"
									maxlength="33"
									:show-word-limit="true"
									@input="val => setDetailForm(val, 'rmk')"
									:readonly="detailForm.pgsStCd == 40"
								/>
							</td>
							<th></th>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourStts/store/helpers';
import FileUploadList from '@qms/Components/FileUploadList.vue';
import RmkHistory from './RmkHistory.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { FileUploadList, RmkHistory },
	computed: {
		...rootComputed,
		...serviceComputed,
		setDisabled() {
			return !(this.getCheckReplyAuth_ && this.detailForm.pgsStCd <= 20);
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		powCausFileUpload(saveList) {
			this.setState_({ key: 'isSaved', value: true });
			this.setDetailForm_({ key: 'powCausFile', value: saveList });
		},
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		},
		setDetailForm(value, key) {
			try {
				this.setState_({ key: 'isSaved', value: true });
				if (key === 'mdvDd' && value && value < this.$moment().format('YYYYMMDD')) {
					value = this.$moment().format('YYYYMMDD');
					// 대책일자는 과거 날짜가 될 수 없습니다
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001621'), [this.getMessage_('QWCC001444')]));
				}
				this.setDetailForm_({ key, value });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		commInput({ key, value }) {
			this.setState_({ key: 'isSaved', value: true });
			this.setSelectedRow_({ key, value });
		}
	}
};
</script>
